import { createContext, useReducer } from "react";
import reducer, { initState } from "./reducer";

export const OrderContext = createContext();

export default function OrderProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initState);

  return (
    <OrderContext.Provider value={{ state, dispatch }}>
      {children}
    </OrderContext.Provider>
  );
}
